// extracted by mini-css-extract-plugin
export var pillWrapper = "_gw-0";
export var showOverflow = "_gw-1";